(function () {
    'use strict';

    angular.module('app.banks', []);
})();